import { APP_INITIALIZER, FactoryProvider } from '@angular/core';

import { ThemeService } from '@modules/core/services';

function initFactory(themeService: ThemeService) {
  return () => themeService.injectTheme();
}

export const initProvider: FactoryProvider = {
  provide: APP_INITIALIZER,
  useFactory: initFactory,
  deps: [ThemeService],
  multi: true,
};
